import { Component, Inject, TemplateRef } from '@angular/core';
import { DIALOG_DATA } from '@angular/cdk/dialog';

@Component({
    selector: 'fcp-dialog',
    template: `<ng-container *ngTemplateOutlet="data.template"></ng-container>`,
    standalone: false
})
export class FcpDialogComponent {
    constructor(
        @Inject(DIALOG_DATA)
        public data: {
            template: TemplateRef<any>;
        }
    ) {}
}
